import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2053Status: 'idle',
    startProcess2053Error: undefined as any,
    loadUserParamsProcess2053Status: 'idle',
    loadUserParamsProcess2053Error: undefined as any,

    process2053List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2053 = createAsyncThunk('process2053Slice/startProcess2053', async ({ process2053 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2053/`,
        prepareData(process2053),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2053Status } = getState().process2053Slice
        return startProcess2053Status !== 'pending'
    }
})

export const loadUserParamsProcess2053 = createAsyncThunk('process2053Slice/loadUserParamsProcess2053', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2053/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2053Status } = getState().process2053Slice
        return loadUserParamsProcess2053Status !== 'pending'
    }
})

const Process2053Slice = createSlice({
    name: 'process2053Slice',
    initialState,
    reducers: {
        resetstartProcess2053: (state) => {
            state.job = undefined
            state.startProcess2053Error = undefined
        },
        resetstartProcess2053Error: (state) => {
            state.startProcess2053Error = undefined
        },
        resetloadUserParamsProcess2053: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2053Error = undefined
        },
        resetloadUserParamsProcess2053Error: (state) => {
            state.loadUserParamsProcess2053Error = undefined
        },
        removeFromProcess2053ListById: (state, action) => {
            state.process2053List = state.process2053List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2053ListByIds: (state, action) => {
            state.process2053List = state.process2053List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2053List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2053Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2053List = []
            state.startProcess2053Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2053.pending, (state) => {
            state.startProcess2053Status = 'pending'
            state.startProcess2053Error = undefined
        })
        builder.addCase(startProcess2053.fulfilled, (state, action) => {
            state.startProcess2053Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2053.rejected, (state, action) => {
            state.startProcess2053Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2053Error = action.error.message
            } else {
                state.startProcess2053Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2053.pending, (state) => {
            state.loadUserParamsProcess2053Status = 'pending'
            state.loadUserParamsProcess2053Error = undefined
        })
        builder.addCase(loadUserParamsProcess2053.fulfilled, (state, action) => {
            state.loadUserParamsProcess2053Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2053.rejected, (state, action) => {
            state.loadUserParamsProcess2053Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2053Error = action.error.message
            } else {
                state.loadUserParamsProcess2053Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2053,
    resetstartProcess2053Error,
    resetloadUserParamsProcess2053,
    resetloadUserParamsProcess2053Error,
    removeFromProcess2053ListById,
    removeFromProcess2053ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2053Slice.actions
export default Process2053Slice.reducer
